import React, { FunctionComponent } from 'react';
import { DeepLinkBanner } from 'components/DeepLinkBanner';
import { useNativeEvents } from 'hooks/useNativeEvents';
import { useAppSelector } from 'hooks/redux';

export const ChannelDeepLinkBanner: FunctionComponent = () => {
  const { nativeUrlSchemeLink } = useNativeEvents();
  const requiresAccesscode = useAppSelector(
    (state) => state.channel.requiresAccesscode
  );
  const channelDetails = useAppSelector(
    (state) => state.channel.channelDetails
  );
  const channelAccesscodeDetails = useAppSelector(
    (state) => state.channel.accessCodeDetails
  );

  const deepLink = nativeUrlSchemeLink('mixlr', 'channel', {
    url: window.location.origin,
    name: requiresAccesscode
      ? channelAccesscodeDetails?.username
      : channelDetails?.username,
    theme_color: requiresAccesscode
      ? channelAccesscodeDetails?.themeColor
      : channelDetails?.themeColor,
    logo_url: requiresAccesscode
      ? channelAccesscodeDetails?.channelLogo.image.small
      : channelDetails?.channelLogo.image.small
  });

  return <DeepLinkBanner deepLink={deepLink} />;
};
